import {
  GetDoctorContactDetailsActionTypes,
  GET_DOCTOR_CONTACT_DETAILS_FAIL,
  GET_DOCTOR_CONTACT_DETAILS_LOADING,
  GET_DOCTOR_CONTACT_DETAILS_SUCCESS,
  GetDoctorContactDetailsState,
  GET_DOCTOR_CONTACT_DETAILS_UPDATE_API_MSG,
  GET_DOCTOR_CONTACT_DETAILS_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorContactDetailsRes } from "./Model";

const initialStateGetPosts: GetDoctorContactDetailsState = {
  loading: false,
  getDoctorContactDetailsRes: {} as GetDoctorContactDetailsRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorContactDetailsReducer = (
  state = initialStateGetPosts,
  action: GetDoctorContactDetailsActionTypes
): GetDoctorContactDetailsState => {
  switch (action.type) {
    case GET_DOCTOR_CONTACT_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        getDoctorContactDetailsRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_CONTACT_DETAILS_FAIL:
      return {
        ...state,
        getDoctorContactDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_CONTACT_DETAILS_UPDATE_API_MSG:
      return {
        ...state,
        getDoctorContactDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_CONTACT_DETAILS_UPDATE_API_RES:
      return {
        ...state,
        getDoctorContactDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
